module.exports = __webpack_public_path__ + "img/widget-left.7725a325.svg";